import { Heading } from '@chakra-ui/react';
import React from 'react';
export const ModalSectionOptionTitle = (props) => (React.createElement(Heading, { as: "span", display: "block", variant: "lt-500-md-6" }, props.children));
